import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
  container: {
    overflowX: 'auto',
    overflowY: 'auto',
    padding: '16px',
  },
});
